import React from 'react';
import styles from './StepIndicator.module.scss';

type Step = {
  sp: string;
  pc: string;
};

type StepIndicatorProps = {
  steps: Step[];
  currentStep: number;
};

const CheckIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.36664 11.7692L2.8103 8.2129L3.52297 7.50007L6.36664 10.3437L12.477 4.2334L13.1896 4.94623L6.36664 11.7692Z"
      fill="white"
    />
  </svg>
);

export const StepIndicator: React.FC<StepIndicatorProps> = ({
  steps,
  currentStep,
}) => {
  const renderLabel = (text: string) =>
    text.split('\n').map((line, index, array) => (
      <React.Fragment key={index}>
        {line}
        {index < array.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <div className={styles.stepIndicator}>
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        let status = 'upcoming';
        if (stepNumber < currentStep) {
          status = 'completed';
        } else if (stepNumber === currentStep) {
          status = 'active';
        }

        return (
          <React.Fragment key={index}>
            <div className={`${styles.step} ${styles[status]}`}>
              <div className={styles.circle}>
                {status === 'active' ? <CheckIcon /> : '\u00A0'}
              </div>
              <div className={styles.label}>
                <span className={styles.labelSp}>{renderLabel(label.sp)}</span>
                <span className={styles.labelPc}>{renderLabel(label.pc)}</span>
              </div>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`${styles.line} ${
                  stepNumber < currentStep ? styles.completed : ''
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}; 